import { BotIcon } from './icons.tsx'
import { PARTICIPANT_COLORS, hashString } from './participantColors.js'
import './ContactList.css'

export const ContactList = ({
  contacts,
  loaded,
  onSelectContact,
  onCreateBot,
  selectedContactId,
}: any) => {
  const online = contacts.filter((c: any) => c.online)
  const offline = contacts.filter((c: any) => !c.online)

  // Suppress empty-state CTA until peer discovery has resolved at least once,
  // otherwise the CTA flashes on first paint before peers arrive.
  if (!loaded) return null

  if (contacts.length === 0) {
    return (
      <div className="contact-empty">
        <BotIcon size={40} color="var(--text-dim)" />
        <p className="contact-empty-text">No bots yet</p>
        <button
          type="button"
          className="contact-empty-action"
          data-testid="empty-create-bot"
          onClick={onCreateBot}
        >
          新建一个 LLM 机器人
        </button>
      </div>
    )
  }

  return (
    <div className="contact-list">
      {online.length > 0 && (
        <div className="contact-section">
          <div className="contact-section-title">Online</div>
          {online.map((c: any) => {
            const color = PARTICIPANT_COLORS[hashString(c.roleId) % PARTICIPANT_COLORS.length]
            const selected = selectedContactId === c.roleId
            return (
              <div
                key={c.roleId}
                className={`contact-item contact-item-online${selected ? ' contact-item-selected' : ''}`}
                onClick={() => onSelectContact(c)}
              >
                <div
                  className="contact-avatar"
                  style={{ background: `linear-gradient(135deg, ${color}22, ${color}11)` }}
                >
                  <BotIcon color={color} />
                  <span className="contact-status online" />
                </div>
                <div className="contact-info">
                  <div className="contact-name">
                    {c.displayName}
                    {c.typeName && c.displayName !== c.typeName && (
                      <span className="contact-type"> ({c.typeName})</span>
                    )}
                  </div>
                  {c.description && <div className="contact-desc">{c.description}</div>}
                </div>
              </div>
            )
          })}
        </div>
      )}
      {offline.length > 0 && (
        <div className="contact-section">
          <div className="contact-section-title">Offline</div>
          {offline.map((c: any) => {
            const color = PARTICIPANT_COLORS[hashString(c.roleId) % PARTICIPANT_COLORS.length]
            const selected = selectedContactId === c.roleId
            return (
              <div
                key={c.roleId}
                className={`contact-item contact-item-offline${selected ? ' contact-item-selected' : ''}`}
                onClick={() => onSelectContact(c)}
              >
                <div
                  className="contact-avatar"
                  style={{ background: `linear-gradient(135deg, ${color}22, ${color}11)` }}
                >
                  <BotIcon color="var(--text-tertiary)" />
                  <span className="contact-status offline" />
                </div>
                <div className="contact-info">
                  <div className="contact-name">{c.displayName}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
